$(document).ready(function () {
    const windowLocation = window.location.href;
    // Local storage keys used across the flow
    const STORAGE_KEYS = {
      SETTING_INFORMATION: "setting-information",
      DIAMOND_INFORMATION: "diamond-information",
      DIAMOND_STEP_FIRST: "diamond_step_first",
      CUSTOM_RING_STEP: "customRingStep",
      LUXE_SETTING_FLAG: "luxe-setting-flag",
      PRODUCT_CARAT_RANGE: "product-carat-range",
    };
  
    // Shared state for the current setting configuration
    const settingProductState = {};
  
    // Small utilities
    function getJsonFromLocalStorage(key) {
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      } catch (e) {
        return null;
      }
    }
  
    function setJsonToLocalStorage(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  
    function removeFromLocalStorage(key) {
      localStorage.removeItem(key);
    }
  
    function truncateText(text, maxLength) {
      if (!text || typeof text !== "string") return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    }
  
    function isDiamondStepFirst() {
      return !!localStorage.getItem(STORAGE_KEYS.DIAMOND_STEP_FIRST);
    }
  
    // Basic UI hooks
    $(".popup-content-wrapper .close-popup").on("click", function () {
      theme.close_popup();
    });
  
    $(document).on({
      ajaxStart: function () {
        $(".loader").addClass("active");
      },
      ajaxStop: function () {
        $(".loader").removeClass("active");
      },
    });
  
    const helper_function = {
      add_setting_in_localstorage: function () {
        $("#select-diamond-type-popup .button").on("click", function () {
          $(this).addClass("button-active");
          setJsonToLocalStorage(STORAGE_KEYS.SETTING_INFORMATION, settingProductState);
        });
      },
      add_loader_to_button: function () {
        // Reserved for submit button loader logic if needed in future
      },
    };
    helper_function.add_setting_in_localstorage();
    helper_function.add_loader_to_button();
    // Multi-step engagement ring journey helpers
    const engagement_ring_step = {
      active_step: function (current) {
        $(".steps-wrapper .step").removeClass("active");
        $(current).addClass("active");
      },
      start_over: function () {
        $("#start-over").on("click", function () {
          theme.open_popup($("#start-over-popup"));
        });
        $("#start-over-popup .close-button").on("click", function () {
          theme.close_popup();
        });
        $("#start-over-popup .clear-ring-data").on("click", function () {
          removeFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
          removeFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
        });
      },
  
      get_step_order: function () {
        const diamond_step_first = isDiamondStepFirst();
        const has_ring_setting = !!localStorage.getItem(STORAGE_KEYS.SETTING_INFORMATION);
        const has_diamond = !!localStorage.getItem(STORAGE_KEYS.DIAMOND_INFORMATION);
        // When first step is diamond and user removes diamond, ring becomes first step
        if (has_ring_setting && !has_diamond && diamond_step_first) {
          removeFromLocalStorage(STORAGE_KEYS.DIAMOND_STEP_FIRST);
          return false;
        }
        // When first step is ring and user removes setting, diamond becomes first step
        if (!has_ring_setting && has_diamond && !diamond_step_first) {
          localStorage.setItem(STORAGE_KEYS.DIAMOND_STEP_FIRST, "true");
          $(".steps-wrapper .step-2").addClass("first-step").find(".count").text(1);
          $(".steps-wrapper .step-1").find(".count").text(2);
        }
        // When user clicks diamond link first and ring is not selected
        if (diamond_step_first) {
          $(".steps-wrapper .step-2").addClass("first-step").find(".count").text(1);
          $(".steps-wrapper .step-1").find(".count").text(2);
        }
      },
      set_step_order: function () {
        const href_link = windowLocation;
        const has_ring_setting = !!localStorage.getItem(STORAGE_KEYS.SETTING_INFORMATION);
        const has_diamond = !!localStorage.getItem(STORAGE_KEYS.DIAMOND_INFORMATION);
        if (!has_ring_setting &&
          (href_link.indexOf("lab-diamonds") > 0 ||
            href_link.indexOf("color-diamonds") > 0 ||
            href_link.indexOf("lab-grown-diamonds") > 0 ||
            href_link.indexOf("natural-diamonds") > 0)) {
          localStorage.setItem(STORAGE_KEYS.DIAMOND_STEP_FIRST, "true");
        } else if (!has_diamond) {
          removeFromLocalStorage(STORAGE_KEYS.DIAMOND_STEP_FIRST);
        }
      },
  
      set_active_step: function () {
        if (windowLocation.indexOf(theme.ring_setting_handle) > -1 || localStorage.getItem(STORAGE_KEYS.CUSTOM_RING_STEP) === "engagement-rings" || theme.product.tags.indexOf("ring-setting-product") > -1 || theme.product.tags.indexOf("cyo-engagement-ring") > -1) {
          engagement_ring_step.active_step(".step-1");
        }
        if (windowLocation.indexOf("diamonds") > -1 || theme.product.template === "diamonds") {
          engagement_ring_step.active_step(".step-2");
        }
        if (windowLocation.indexOf("final-ring") > -1) {
          engagement_ring_step.active_step(".step-3");
        }
      },
      step_update_diamond_information: function () {
        const localStepDiamond = getJsonFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
        const diamondCollectionUrl = localStepDiamond && localStepDiamond.current_diamond_type === "natural"
            ? `/collections/${theme.natural_diamond_handle}`
            : `/collections/${theme.lab_diamond_handle}`;
        if (localStepDiamond) {
          const truncatedTitle = truncateText(localStepDiamond.diamond_name, 30);
          $(".step-2-product-info-selection").removeClass("hidden");
          $(".step-2-product-info-selection").find("p:first").text(truncatedTitle);
          $(".step-2-product-info-selection")
            .find("p:last span")
            .text("$" + localStepDiamond.total_discounted_sales_price);
          $(".step-2").addClass("has-active-item");
          $(".step-2 img").attr("src", localStepDiamond.image_url);
          $(".step-2 .product-link .view").attr("href",`${theme.diamond_product_url}?sku=${localStepDiamond.cert_num}`);
          $(".step-2 .product-link .change").attr("href", diamondCollectionUrl);
  
          // When user clicks "Change" on step 2, clear stored diamond info
          $(".step-2 .product-link .change")
            .off("click.customChange")
            .on("click.customChange", function () {
              removeFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
            });
        } else {
          $(".step-2").removeClass("has-active-item");
          $(".step-2-product-info-selection").addClass("hidden");
        }
  
        $(".step-2 .product-link .remove").on("click", function (e) {
          e.preventDefault();
          removeFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
          $(".step-2 .current-diamond-option").hide();
          $(".step-2 .icon-wrapper").css("display", "flex");
          window.location.href = diamondCollectionUrl;
        });
      },
  
      step_update_setting_information: function () {
        const localStepSetting = getJsonFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
        console.log("localStepSetting", localStepSetting);
        if (localStepSetting) {
          const truncatedTitle = truncateText(localStepSetting.title, 30);
          $(".step-1-product-info-selection").removeClass("hidden");
          $(".step-1").addClass("has-active-item");
          $(".step-1 .product-img img").attr("src", localStepSetting.image);
          $(".step-1-product-info-selection").find("p:last span").text(localStepSetting.price_formatted);
          $(".step-1-product-info-selection").find("p:last s").text(localStepSetting.compare_price_formatted);
          $(".step-1-product-info-selection").find("p:first").text(truncatedTitle);
          $(".step-1 .product-link .view").attr("href",`${localStepSetting.url}?variant=${localStepSetting.selected_variant}`);
          $(".step-1 .product-link .change").attr("href",`/collections/${theme.ring_setting_handle}`);
  
          // When user clicks "Change" on step 1, clear stored setting info
          $(".step-1 .product-link .change")
            .off("click.customChange")
            .on("click.customChange", function () {
              removeFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
              removeFromLocalStorage("setting-url");
            });
        } else {
          $(".step-1").removeClass("has-active-item");
          $(".step-1 .current-ring-setting").hide();
          $(".step-1-product-info-selection").addClass("hidden");
        }
  
        $(".step-1 .product-link .remove").on("click", function (e) {
          e.preventDefault();
          removeFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
          removeFromLocalStorage("setting-url");
          $(".step-1 .current-ring-setting").hide();
          $(".step-1 .icon-wrapper").css("display", "flex");
          window.location.href = `/collections/${theme.ring_setting_handle}`;
        });
      },
  
      step_update_final_step: function () {
        const localStepSetting = getJsonFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
        const localStepDiamond = getJsonFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
        if (localStepSetting || localStepDiamond) {
          $(".start-over-button").removeClass("hidden");
        }
        if (localStepSetting && localStepDiamond) {
          const truncatedTitle = truncateText(localStepSetting.title, 20);
  
          $(".step-3").addClass("has-active-item");
          $(".step-3-product-info-selection").removeClass("hidden");
          $(".step-3-product-info-selection").find("p:first").text(truncatedTitle);
          $(".step-3 .product-img img").attr("src", localStepSetting.image);
  
          // Final engagement ring price = setting price + diamond price
          const settingPrice = parseInt(localStepSetting.price/100) || 0;
          const diamondPrice = parseInt(localStepDiamond.total_discounted_sales_price) || 0;
          console.log("settingPrice", settingPrice, settingPrice + diamondPrice);
          console.log("diamondPrice", diamondPrice);
          const finalPrice = settingPrice + diamondPrice;
  
          if (finalPrice > 0) {
            const formattedFinalPrice = "$" + finalPrice.toLocaleString();
            $(".step-3-product-info-selection").find("p:last span").text(formattedFinalPrice);
          }
  
          $(".step-3").on("click", function () {
            const diamond_shape = localStepDiamond.shape;
            const variant_id = localStepSetting.variants[diamond_shape];
  
            window.location.href = `${localStepSetting.url}?variant=${variant_id}&view=final-ring&diamond=${localStepDiamond.cert_num}`;
          });
        }
      },
  
      add_link_to_step: function () {
        $(".step-1").on("click", function (e) {
          if (e.target.nodeName === "A") return;
  
          const localStepSetting = getJsonFromLocalStorage(STORAGE_KEYS.SETTING_INFORMATION);
  
          if (localStepSetting) {
            window.location.href = `${localStepSetting.url}?variant=${localStepSetting.selected_variant}`;
          } else {
            window.location.href = `/collections/${theme.ring_setting_handle}`;
          }
        });
  
        $(".step-2").on("click", function (e) {
          if (e.target.nodeName === "A") return;
  
          const localStepDiamond = getJsonFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
  
          if (localStepDiamond) {
            window.location.href = `${theme.diamond_product_url}?sku=${localStepDiamond.cert_num}`;
          } else {
            window.location.href = `/collections/${theme.lab_diamond_handle}`;
          }
        });
      },
    };
  
    engagement_ring_step.set_active_step();
    engagement_ring_step.add_link_to_step();
    engagement_ring_step.step_update_diamond_information();
    engagement_ring_step.step_update_setting_information();
    engagement_ring_step.step_update_final_step();
    // engagement_ring_step.set_step_order();
    // engagement_ring_step.get_step_order();
    engagement_ring_step.start_over();
  
    // Show setting and diamond information on PDP
    $(".product-form__add-to-setting button").on("click", function () {
      $(this).addClass("loading");
      $(this).find(".loading__spinner").removeClass("hidden");
      const $productInfo = $(".product__info-wrapper");
      const title = $productInfo.data("title");
      const variantId = $productInfo.find('[name="id"]').val();
      const selectedVariant = $productInfo.find(
        '.product-hidden-variant-info-item[data-variant-id="' + variantId + '"]'
      );
  
      const variantShape = $.trim(selectedVariant.data("variant-shape"));
      const product_price = selectedVariant.data("variant-price");
      const product_price_formatted = selectedVariant.data("variant-price-formatted");
      const product_compare_price = selectedVariant.data("variant-compare-price");
      const product_compare_price_formatted = selectedVariant.data(
        "variant-compare-price-formatted"
      );
      const selected_metal_color = selectedVariant.data("variant-metal-color");
      const variant_image = selectedVariant.data("variant-image");
  
      const product_shape_array = [];
      const selected_metal_color_variant_obj = {};
  
      $productInfo.find(".product-hidden-variant-info-item").each(function () {
        const variantTitleHandle = $(this).data("variant-handle");
        const variantIdItem = $(this).data("variant-id");
        const variantShapeItem = $.trim($(this).data("variant-shape"));
        if (variantTitleHandle.indexOf(selected_metal_color) > -1 && product_shape_array.indexOf(variantShapeItem) < 0) {
          selected_metal_color_variant_obj[variantShapeItem] = variantIdItem;
          product_shape_array.push(variantShapeItem);
        }
      });
  
      const settingUrl = "/products/" + theme.product.handle;
      settingProductState.url = settingUrl;
      settingProductState.title = title;
      settingProductState.price = product_price;
      settingProductState.price_formatted = product_price_formatted;
      settingProductState.compare_price = product_compare_price;
      settingProductState.compare_price_formatted = product_compare_price_formatted;
      settingProductState.selected_variant = variantId;
      settingProductState.variants = selected_metal_color_variant_obj;
      settingProductState.shape = variantShape;
      settingProductState.image = variant_image;
      settingProductState.tags = theme.product.tags;
  
      if (theme.product.tags.indexOf("luxury-engagement-rings") > -1) {
        localStorage.setItem(STORAGE_KEYS.LUXE_SETTING_FLAG, "true");
      }
  
      if (theme.product.tags.indexOf("the-reserve") > -1 && theme.product.product_carat_range) {
        localStorage.setItem(STORAGE_KEYS.PRODUCT_CARAT_RANGE, theme.product.product_carat_range);
      }
  
      removeFromLocalStorage(STORAGE_KEYS.CUSTOM_RING_STEP);
  
      const diamond_information = getJsonFromLocalStorage(STORAGE_KEYS.DIAMOND_INFORMATION);
  
      if (diamond_information) {
        const diamond_shape = diamond_information.shape;
        const variant_id = settingProductState.variants[diamond_shape];
  
        setJsonToLocalStorage(STORAGE_KEYS.SETTING_INFORMATION, settingProductState);
        window.location.href = `${settingUrl}?variant=${variant_id}&view=final-ring&diamond=${diamond_information.cert_num}`;
      } else {
        setJsonToLocalStorage(STORAGE_KEYS.SETTING_INFORMATION, settingProductState);
        window.location.href = "/collections/lab-grown-diamonds";
      }
    });
  
    // Mark when a setting card is clicked so we can set step state on PDP
    $("#product-loop .product-card").on("click", function () {
      localStorage.setItem(STORAGE_KEYS.CUSTOM_RING_STEP, "engagement-rings");
    });
  
    // Remove diamond shape options from ring settings PDP if a diamond is already selected
    const selectedDiamondRaw = localStorage.getItem(STORAGE_KEYS.DIAMOND_INFORMATION);
    const is_ring_settings_product = $('[data-product-type="engagement-ring"]');
  
    if (selectedDiamondRaw && is_ring_settings_product.length) {
      try {
        const selected_diamond_shape = JSON.parse(selectedDiamondRaw).shape;
  
        $(".swatch-shape .swatch-element").each(function () {
          if ($(this).data("value") !== selected_diamond_shape) {
            $(this).addClass("disabled");
          }
        });
      } catch (e) {
        // If parsing fails, do nothing – UI will show all shapes
      }
    }
  });
  